import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=a175bcf4&scoped=true"
import script from "./AppPagination.vue?vue&type=script&lang=js"
export * from "./AppPagination.vue?vue&type=script&lang=js"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=a175bcf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a175bcf4",
  null
  
)

export default component.exports